import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import LenisProvider from "./components/LenisProvider";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Work from "./pages/Work";
import GetQuote from "./pages/GetQuote";

function App() {
  return (
    <div className="App">
      <LenisProvider>
        <BrowserRouter>
          <Navigation />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/work" element={<Work />} />
            <Route path="/quote" element={<GetQuote />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </LenisProvider>
    </div>
  );
}

export default App;
